<template>
    <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content">
            <!-- <img src="..\..\src\assets\img\palleggia.gif" style="width: 400px;"/> -->
            <!-- <img v-if="[4].includes(user.id)" src="..\..\src\assets\img\peter.gif" style="width: 400px;"/> -->
            <span class="spinner"></span>
        </div>
    </div>
</div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
export default {
  name: 'Loader',

  components: {
  },

  data() {
    return {
      // user: JSON.parse(atob(localStorage.getItem('user'))).user[0]
    }
  },

  created(){
  },

  mounted(){
  },

  methods: {
  },

  computed: {
  },

  watch: {
  },
}
</script>


<style scoped>
.overlay {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    background: linear-gradient(236deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.4906337535014006) 100%);
    z-index: 3;
    max-height: 100vh;
}


.overlay__inner {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
}

.overlay__content {
    left: 50%;
    position: absolute;
    top: 55%;
    transform: translate(-50%, -50%);
}

.spinner {
    width: 60px;
    height: 60px;
    display: inline-block;
    border-width: 2px;
    border-color: #2196f3;
    border-top-color: rgba(255, 255, 255, 0);
    animation: spin 0.6s infinite linear;
    border-radius: 100%;
    border-style: solid;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
